<script>
export default {
  methods: {
    getRoundedValue: function (value) {
      if (value === null) {
        return ''
      } else {
        var coef = 10
        return Math.round(value * coef) / coef
      }
    },
    getFormatedValue: function (value) {
      if (value == null) {
        return '\u2022'
      } else if (isNaN(value)) {
        return value
      } else {
        return this.getRoundedValue(value)
      }
    },
    splitUnit: function (unit) {
      if (unit !== null) {
        return unit.split(/(?=\/m)/g) // split and keep separator on the right side of the split
      } else {
        return [null, null]
      }
    },
    placeChoiceName ({name, identifier}) {
      return `${name} (${identifier})`
    },
    multiselectLimitText: (count) => count > 1 ? `et ${count} autres` : `et ${count} autre`
  },
  filters: {
    valueIfNotNone: function (value) {
      if (value !== null) {
        return value
      } else {
        return '-'
      }
    },
    formatIntNumber: function (value) {
      return parseInt(value).toLocaleString()
    },
    formatPrice: function (value) {
      return value.toFixed(2).toLocaleString()
    },
    displayPercentage: function (value) {
      var percentage = parseFloat(value * 100).toFixed(2)
      return percentage + '%'
    },
    displayPercentageAsInt: function (value) {
      var percentage = parseFloat(value * 100).toFixed(0)
      return percentage + '%'
    },
    yesNoDisplay: function (value) {
      if (value === true) {
        return 'Oui'
      } else {
        return 'Non'
      }
    },
    toLowerCase: function (value) {
      return value.toLowerCase()
    },
    toString: function (value) {
      return value.toString()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/ValuesDisplayMixin.vue